import { useProperty } from '@eti/providers';
import { endpoints } from '../../../constants/routesAndApisConstants';
import { useJson } from '../../../common/custom-hooks/json';
import type { CarrierInformationTextsType } from '../models';

const getTravelerDetailsTextUrl = (
  ticketingCarriers: string[] = [],
  carriersForBaggageInfo: string[] = [],
  carriersForCarrierInfo: string[] = [],
) => {
  if (!carriersForBaggageInfo.length && !carriersForCarrierInfo.length) {
    return '';
  }

  const carrierCodesForBaggageInfo = ticketingCarriers.filter(
    (ticketingCarrierCode) => carriersForBaggageInfo?.includes(ticketingCarrierCode),
  );
  const carrierCodesForCarrierInfo = ticketingCarriers.filter(
    (ticketingCarrierCode) => carriersForCarrierInfo?.includes(ticketingCarrierCode),
  );

  if (!carrierCodesForBaggageInfo.length && !carrierCodesForCarrierInfo.length) {
    return '';
  }

  const searchParams = new URLSearchParams();
  if (carrierCodesForBaggageInfo.length) {
    searchParams.set('carrierCodesForBaggageInfo', `${carrierCodesForBaggageInfo}`);
  }
  if (carrierCodesForCarrierInfo.length) {
    searchParams.set('carrierCodesForCarrierInfo', `${carrierCodesForCarrierInfo}`);
  }

  return `${endpoints.TRAVELER_DETAILS_TEXTS}?${searchParams}`;
};

const useFetchCarrierSpecificText = (
  carrierCodes: string[],
): { carrierBaggageTexts: string[]; carrierInformationTexts: CarrierInformationTextsType[] } => {
  const { p } = useProperty();

  const textUrl = getTravelerDetailsTextUrl(
    carrierCodes,
    p('TravelerDetails.BaggageInformation.Carriers'),
    p('TravelerDetails.CarrierInformation.Carriers'),
  );

  const { data } = useJson(textUrl);

  if (data?.model) {
    return data.model;
  }
  return { carrierBaggageTexts: [], carrierInformationTexts: [] };
};

export default useFetchCarrierSpecificText;
